import { Type } from "@angular/core";

export class ZoneItem {
  constructor(
    public component: string,
    public title: string,
    public data: any,
    public error: string,
    public width: number,
    public isZoom: boolean,
  ) {}

  needpaddingLeft: boolean;
}
